// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'DepEd file details ' + \$ctrl.fileId"></sub-header>


  <div class="filters">
    <div class="labelled-field">
      <label>Payment status</label>
      <select ng-model="\$ctrl.status"
              ng-options="s as s | prettyEnum for s in \$ctrl.statuses"></select>
    </div>
    <button type="button"
            class="btn btn-primary"
            ng-click="\$ctrl.display()">View
    </button>
  </div>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.goBack()">
      Go back
    </button>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/deped/batch-deped-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;